function autoPlayDeferredMedia() {
  document.querySelectorAll('deferred-media').forEach((dm) => {
    if (!dm.getAttribute('chargé')) {
      const content = document.createElement('div');
      content.appendChild(dm.querySelector('template').content.firstElementChild.cloneNode(true));
      dm.setAttribute('chargé', true);
      dm.appendChild(content);
    }
    const poster = dm.querySelector('[id^="Deferred-Poster-"]');
    if (poster) poster.style.display = 'none';
    const video = dm.querySelector('video');
    if (video) { video.muted = true; video.play(); }
  });
}

setTimeout(autoPlayDeferredMedia, 1500);
